/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';

import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import GridProducts from '@/ui/GridProducts/GridProducts';

import Campaign from '../Campaign/Campaign';

import styles from './CampaignList.module.scss';

const CampaignList = ({ data, href }) => (
  <div
    className={'small-margin'}
    itemScope
    itemType='https://schema.org/ItemList'
  >
    <div className={classNames(['wrapper', styles.titleWrapper])}>
      <SectionTitle className={styles.title} titleModify='title--large'>
        {data?.title}
      </SectionTitle>
    </div>
    <GridProducts className={styles.wrapper}>
      {data?.items?.map((item, index) => (
        <Campaign data={item} key={index} href={href} />
      ))}
    </GridProducts>
  </div>
);

export default CampaignList;
